const ACCOUNT_BASE_PATH = '/account';

function normalizeSuffix(suffix = ''): string {
    if (!suffix || suffix === '/') {
        return '';
    }

    return suffix.startsWith('/') ? suffix : `/${suffix}`;
}

export function buildAccountPath(suffix = ''): string {
    return `${ACCOUNT_BASE_PATH}${normalizeSuffix(suffix)}`;
}

export function buildAccountSettingsPath(): string {
    return buildAccountPath('/settings');
}
